import { Component, OnInit, ViewChild } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { Location, formatDate } from "@angular/common";
import { ElementRef } from "@angular/core";
import { PagerService } from "../../core/services/pager.service";
import { MatDatepicker } from "@angular/material/datepicker";
import { from } from "rxjs";
import * as $ from "jquery";
//import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-retagging-of-calls",
  templateUrl: "./retagging-of-calls.component.html",
  styleUrls: ["./retagging-of-calls.component.css"],
})
export class RetaggingOfCallsComponent implements OnInit {
  @ViewChild("frmDate") frmDate: MatDatepicker<Date>;
  @ViewChild("toDate") toDate: MatDatepicker<Date>;
  @ViewChild("modalcontent") modalcontent: ElementRef;
  divSearch = "none";
  divSubmit = "none";
  divDetails = "none";
  showMsg = "none";
  AlertForAccess = "none";
  divWBSElement = "none";
  divApprover = "none";
  divCostCenter = "none";
  showWBSElement = false;
  showApprover = false;
  isCheckAll = false;
  displayPopUp = "none";
  select_all_data = false;
  selected_copy_data = null;
  retain_pageNumber = null;

  public Country;
  public LoginEnterpriseID;
  public ErrorMessage;
  public DeviceTypeList;
  public Role;
  public country;
  public Type;
  //public DeviceType;
  public FromDate;
  public ToDate;
  public Countries;
  public RetaggingDetails;
  public MarkList;
  public dlstCountries;
  public selectedDeviceType;
  public dlstCallStatus;
  public selectedAll: boolean;
  public showModalMarkCalls:boolean = false;
  public txtenterpriseID;
  public CountAll;
  public Count = 0;
  public successfulData: Details = new Details();
  private mainCountSingle;
  private maincount;
  private dateYesterday: Date = new Date();

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  //for loading img
  dataLoader: boolean;
  public rowData = [];

  constructor(
    private CAPService: CAPService,
    private location: Location,
    private pagerService: PagerService //,private ngbModal: NgbModal
  ) {
    this.Country = CAPService.country;
    this.LoginEnterpriseID = CAPService.enterpriseid;
    this.ErrorMessage =
      "This section is not enabled. Please contact the Online support or check User Guidelines section for any access or tool issue.";
    this.DeviceTypeList = [
      /*{ name: 'Skype', }, */
      { name: "Cisco" },
      { name: "Teams" },
    ];
    this.Role = CAPService.Role;
    this.txtenterpriseID = "";
    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      location.go("/profile");
      window.location.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
    //this.DeviceType = CAPService.DeviceType;
    this.FromDate = this.formatDate(this.prevMonthFirstDate);
    this.ToDate = this.formatDate(this.prevMonthLastDate);
    this.successfulData.selected = {};
    this.RetaggingDetails = {};
    this.dataLoader = false;
  }

  ngOnInit(): void {
    this.CAPService.AudiLogin(
      "RetaggingOfCalls",
      this.LoginEnterpriseID
    ).subscribe((success) => {});
    this.CAPService.CountryList("N", "N").subscribe((data) => {
      this.Countries = data;
    });
    this.CAPService.GetRetaggingDetails().subscribe((data) => {
      debugger;
      this.RetaggingDetails = data;
    });
    this.CAPService.DropdownValues("MarkAsList", "All").subscribe((data) => {
      this.MarkList = data;
    });
  }

  // now = new Date();
  // prevMonthLastDate = new Date(this.now.getFullYear(), this.now.getMonth(), 0);
  // prevMonthFirstDate = new Date(this.now.getFullYear() - (this.now.getMonth() > 0 ? 0 : 1), (this.now.getMonth() - 1 + 12) % 12, 1);

  prevMonthFirstDate = new Date(
    this.dateYesterday.setDate(this.dateYesterday.getDate() - 1)
  );
  prevMonthLastDate = new Date(
    this.dateYesterday.setDate(this.dateYesterday.getDate())
  );

  formatDateComponent(dateComponent) {
    return (dateComponent < 10 ? "0" : "") + dateComponent;
  }
  formatDate(date) {
    return (
      date.getFullYear() +
      "-" +
      this.formatDateComponent(date.getMonth() + 1) +
      "-" +
      this.formatDateComponent(date.getDate())
    );
  }

  formatDateValue(date: Date) {
    const format = 'yyyy-MM-dd';
    const locale = 'en-US';
    var result = formatDate(date,format,locale);
    return result;
  }

  showFromDatePicker() {
    this.frmDate.open();
  }

  showtoDatePicker() {
    this.toDate.open();
  }

  DeviceTypeEvent(type) {
    this.divDetails = "none";
    this.dataLoader = true;
    this.FromDate = this.formatDate(this.prevMonthFirstDate);
    this.ToDate = this.formatDate(this.prevMonthLastDate);
    this.CAPService.DropdownValues("MarkAsList", "All").subscribe((data) => {
      this.MarkList = data;
    });

    this.selectedDeviceType = type;
    this.RetaggingDetails.DeviceType = type;
    if (
      this.selectedDeviceType == "Skype" ||
      this.selectedDeviceType == "Cisco" ||
      this.selectedDeviceType == "Teams"
    ) {
      if (
        this.RetaggingDetails.DeviceType == "Skype" ||
        this.RetaggingDetails.DeviceType == "Cisco" ||
        this.selectedDeviceType == "Teams"
      ) {
        this.showMsg = "none";
        this.AlertForAccess = "none";
        this.divSearch = "block";
        this.divSubmit = "block";
        this.divDetails = "block";
        this.RetaggingDetails.Posted = this.FromDate;
        this.RetaggingDetails.Cduration = this.ToDate;
        this.RetaggingDetails.strType = "GetRetaggingDetails";
        //this.CAPService.TransactRetaggingDetails(this.RetaggingDetails).subscribe(data =>{
        this.CAPService.TransactRetaggingDetails(
          this.RetaggingDetails.DeviceType,
          this.RetaggingDetails.Posted,
          this.RetaggingDetails.Cduration,
          this.RetaggingDetails.strType
        ).subscribe((data) => {
          if (data.length > 0) {
            this.allItems = data;
            this.successfulData = { retagging: data, selected: {} };
            // initialize to page 1
            this.successfulData.retagging.forEach((x) => {
              x["checked"] = false;
            });
            this.setPage(1);
            this.dataLoader = false;
          } else {
            this.divDetails = "none";
            alert("No Records Found");
            this.dataLoader = false;
          }
        });
      } else {
        this.showMsg = "block";
        this.AlertForAccess = "none";
        this.divSearch = "none";
        this.divSubmit = "none";
        this.divDetails = "none";
        this.dataLoader = false;
      }
    } else {
      this.AlertForAccess = "block";
      this.showMsg = "none";
      this.divSearch = "none";
      this.divSubmit = "none";
      this.divDetails = "none";
      this.dataLoader = false;
    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.retagging = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  getTemplate(data) {
    return "display";
  }

  ShowData() {
    debugger;
    this.dataLoader = true;
    this.RetaggingDetails.DeviceType = this.selectedDeviceType;
    this.RetaggingDetails.Posted =
      this.FromDate == "" ? "01/01/1900" : this.formatDateValue(this.FromDate);
    this.RetaggingDetails.Cduration =
      this.ToDate == "" ? "01/01/1900" : this.formatDateValue(this.ToDate);
    // this.RetaggingDetails.Country = this.dlstCountries = '' ? 'N' : this.dlstCountries;
    // this.RetaggingDetails.callStatus = this.dlstCallStatus = '' ? 'N' : this.dlstCallStatus;
    // this.RetaggingDetails.EId = this.txtenterpriseID = '' ? 'N' : this.txtenterpriseID;
    this.RetaggingDetails.Country =
      this.dlstCountries != null || this.dlstCountries != undefined
        ? this.dlstCountries
        : "N";
    this.RetaggingDetails.callStatus =
      this.dlstCallStatus != null || this.dlstCallStatus != undefined
        ? this.dlstCallStatus
        : "N";
    this.RetaggingDetails.EId =
      this.txtenterpriseID != null ? this.txtenterpriseID : "";
    this.RetaggingDetails.strType = "GetRetaggingDetails";

    this.CAPService.TransactRetaggingDetailsSearch(
      this.RetaggingDetails.DeviceType,
      this.RetaggingDetails.Posted,
      this.RetaggingDetails.Cduration,
      this.RetaggingDetails.Country,
      this.RetaggingDetails.callStatus,
      this.RetaggingDetails.EId,
      this.RetaggingDetails.strType
    ).subscribe((data) => {
      //this.CAPService.TransactRetaggingDetails1(this.RetaggingDetails).subscribe(data =>{
      // this.rowData = data;
      if(data.toString() == "Please Enter valid User EnterpriseID and ApplicationID"){
        this.divDetails = "none";
        alert('Please enter valid enterprise Id or\nPlease enter valid application Id');
        this.dataLoader = false;
      }
      else if(data.length > 0){
        this.divDetails = "block";
        this.allItems = data;
        this.successfulData = { retagging: data, selected: {} };
        this.successfulData.selected.callStatus = "";
        this.successfulData.retagging.forEach((x) => {
          x["checked"] = false;
        });
        this.setPage(this.retain_pageNumber || 1);
        this.retain_pageNumber = null;
        this.dataLoader = false;
      } else {
        this.divDetails = "none";
        alert("No Records Found");
        this.dataLoader = false;
      }
    });
  }

  CallStatusChange(data) {
    data.checked = true;
    data.callStatus = data.callStatus || "";
    this.successfulData.selected = Object.assign({}, data);
    this.selected_copy_data = Object.assign({}, data);
    this.MarkAction(data.callStatus);
    this.selectedAll = false;
    this.openModal();
  }

  MarkAction(callStatus) {
    switch (callStatus) {
      case "Personal":
        this.showWBSElement = false;
        this.showApprover = false;
        this.successfulData.selected.wbs = "";
        this.successfulData.selected.approverEid = "";
        break;
      default:
        this.showWBSElement = true;
        this.showApprover = true;
        this.successfulData.selected.wbs = this.selected_copy_data.wbs;
        this.successfulData.selected.approverEid =
          this.selected_copy_data.approverEid;
    }
  }

  checkAll(selectedAll) {
    if (selectedAll) {
      this.isCheckAll = true;
      this.selectedAll = true;
    } else {
      this.isCheckAll = false;
      this.selectedAll = false;
    }

    this.allItems.forEach((markCall) => {
      markCall.checked = selectedAll;
      this.CountAll = 0;
    });

    this.select_all_data = selectedAll;

    this.openModal();
  }

  MarkCallsAdd(modal) {
    this.retain_pageNumber = this.pager.currentPage;
    this.dataLoader = true;
    this.Count = 0;
    let message = "";
    if (!this.successfulData.selected.callStatus) {
      message = "Please select MarkAs";
    }
    if (!this.successfulData.selected.remarks) {
      message = message + "\n" + "Please Enter Remarks";
    }
    if (
      this.successfulData.selected.callStatus == "Business" ||
      this.successfulData.selected.callStatus == "For Verification"
    ) {
      if (!this.successfulData.selected.wbs) {
        message = message + "\n" + "Please Enter WBS";
      }
      if (!this.successfulData.selected.approverEid) {
        message = message + "\n" + "Please Enter Approver";
      }
    }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.dataLoader = true;
      if (
        this.successfulData.selected.wbs ||
        this.successfulData.selected.approverEid
      ) {
        this.CAPService.WBSValidation(
          this.successfulData.selected.wbs
        ).subscribe((data) => {
          if (data.toString() == "False") {
            this.successfulData.selected.wbs = "";
            alert("Please Enter valid WBS");
            this.dataLoader = false;
            return;
          }
          else{
            this.CAPService.EnterpriseIdValidaton(this.successfulData.selected.approverEid).subscribe(data =>{
              if(data.toString() == 'Please Enter valid Enterprise ID'){
                this.successfulData.selected.approverEid = '';
                alert("Please Enter valid Enterprise ID")
                this.divDetails = "none";
                this.dataLoader = false;
                return;
              } else {
                this.dataLoader = true;
                if (this.selectedAll == true) {
                  this.allItems.forEach((markCall) => {
                    this.successfulData.selected.cdrId = markCall.Id;
                    //this.successfulData.selected.cdrId = markCall.Id;
                    this.Save(markCall.Id);
                    // if ($('input:checkbox:checked').length > 1) {
                    //     this.maincount = this.successfulData.retagging.length;
                    // }
                    // else {
                    //     this.mainCountSingle = $('input:checkbox:checked').length;
                    // }
                    // if (markCall.checked) {
                    //     this.successfulData.selected.cdrId = markCall.Id;
                    //     this.Save(markCall.Id);
                    // }
                  });
                } else {
                  this.successfulData.selected.cdrId =
                    this.successfulData.selected.Id;
                  this.Save(this.successfulData.selected.Id);
                }
              }
            });
          }
        });
      } else {
        if (this.selectedAll == true) {
          this.allItems.forEach((markCall) => {
            this.successfulData.selected.cdrId = markCall.Id;
            this.Save(markCall.Id);
            // if ($('input:checkbox:checked').length > 1) {
            //   this.maincount = this.successfulData.retagging.length;
            // }
            // else {
            //     this.mainCountSingle = $('input:checkbox:checked').length;
            // }
            // if (markCall.checked) {
            //     this.successfulData.selected.cdrId = markCall.Id;
            //     this.Save(markCall.Id);
            // }
          });
        } else {
          //this.successfulData.selected.cdrId = $('#mdlCdrId').val();
          this.successfulData.selected.cdrId = this.successfulData.selected.Id;
          this.Save(this.successfulData.selected.cdrId);
        }
      }
    }
  }

  Save(data) {
    this.successfulData.selected.cdrId = data;
    this.successfulData.selected.EId = this.LoginEnterpriseID;
    // this.CAPService.UpdateRetaggingDetails(this.successfulData.selected, data, 'UpdateRetaggingDetails').subscribe(data=>{
    this.CAPService.UpdateRetaggingDetails(
      this.successfulData.selected.remarks,
      this.successfulData.selected.wbs,
      this.successfulData.selected.EId,
      this.successfulData.selected.approverEid,
      this.successfulData.selected.callStatus,
      data,
      "UpdateRetaggingDetails"
    ).subscribe((data) => {
      if (data.toString() == "Success") {
        if (this.selectedAll == true) {
          this.Count++;
          this.CountAll++;
          this.popup("Submit");
        } else {
          alert("Updated Successfully!");
          this.closeModal();
          this.ShowData();
          this.dataLoader = false;
        }
      } else {
        alert("Update Failed!");
        this.dataLoader = false;
      }
    });
  }

  popup(Status) {
    if (this.Count == this.mainCountSingle) {
      if (Status == "Submit") {
        alert("Updated successfully");
        this.showModalMarkCalls = !this.showModalMarkCalls;
        this.closeModal();
        this.ShowData();
        this.selectedAll = false;
        this.dataLoader = false;
      }
    } else if (this.CountAll == this.allItems.length) {
      if (Status == "Submit") {
        alert("Updated successfully for " + this.CountAll + " records!");
        this.closeModal();
        this.ShowData();
        this.select_all_data = false;
        this.selectedAll = false;
        this.dataLoader = false;
      }
    }
    this.select_all_data = false;
  }

  Clear() {
    this.dlstCountries = "";
    this.dlstCallStatus = "";
    this.txtenterpriseID = "";
    this.RetaggingDetails.Posted = "N";
    this.RetaggingDetails.Cduration = "N";
    this.RetaggingDetails.Country = "N";
    this.RetaggingDetails.callStatus = "N";
    this.RetaggingDetails.EId = "";
    this.FromDate = this.formatDate(this.prevMonthFirstDate);
    this.ToDate = this.formatDate(this.prevMonthLastDate);
    this.DeviceTypeEvent(this.selectedDeviceType);
  }

  Reset() {
    this.successfulData.selected = {};
  }

  Close() {
    this.showModalMarkCalls = !this.showModalMarkCalls;
    this.selectedAll = false;
    this.successfulData.retagging.forEach((markCall) => {
      markCall.checked = false;
    });
  }

  closeResult;

  openModal() {
    this.displayPopUp = "block";
    //this.successfulData.selected.callStatus = "";
    document.documentElement.style.overflowY = "hidden";
  }

  closeModal() {
    this.displayPopUp = "none";
    document.documentElement.style.overflowY = "scroll";
    this.isCheckAll = false;
    this.selectedAll = false;
    this.successfulData.retagging.forEach((markCall) => {
      markCall.checked = false;
    });
    this.select_all_data = false;
    this.allItems.forEach((x) => {
      x["checked"] = false;
    });
  }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return  `with: ${reason}`;
  //   }
  // }
}

export class Details {
  retagging;
  selected;
}
